export default __webpack_public_path__ + "static/media/unknown_sensor.ba2cc4c7.svg";